import m from "../../geodata/es2015/franceDepartmentsLow";
window.am4geodata_franceDepartmentsLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/franceDepartmentsLow.js
// module id = null
// module chunks = 